import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseIngredients } from "./UseIngredients";
import { UseMyPC } from "../../hooks/UseMyPC";

export default function IngAutoComplete(props) {
  const { getAllIngredientList } = UseIngredients();
  const [ingredientRes, setIngredientRes] = React.useState();

  const [nameSuggestion, setNameSuggestion] = useState({
    q: "",
    open: false,
    selected: undefined,
  });

  useEffect(() => {
    if (props.lvl7State && props.lvl7State.enName) {
      setNameSuggestion({
        ...nameSuggestion,
        selected: props.lvl7State.enName,
      });
    }
  }, [props.lvl7State]);

  useEffect(() => {
    if (nameSuggestion && nameSuggestion.q.length > 0) {
      getAllIngredientList(
        nameSuggestion.q.replace(/^\s+/, ""),
        (ingredients) => {
          setIngredientRes(ingredients.ingredients);
        }
      );
    }
  }, [nameSuggestion.q]);

  useEffect(() => {
    if (ingredientRes && ingredientRes.length > 0) {
      if (nameSuggestion.q.length > 0) {
        setNameSuggestion({ ...nameSuggestion, open: true });
      }
    }
  }, [ingredientRes]);

  useEffect(() => {
    if (props.reset) {
      setNameSuggestion({
        ...nameSuggestion,
        selected: undefined,
        q: "",
      });
      props.setter({
        ...props.lvl7State,
        ingredientID: undefined,
        faName: "",
        enName: "",
      });
      props.setReset(false);
    }
  }, [props.reset]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Autocomplete
        fullWidth
        freeSolo
        filterOptions={(options, state) => options}
        onChange={(evt, value) => {
          if (value) {
            if (props.cluster) {
              setNameSuggestion({
                ...nameSuggestion,
                selected: value.enName,
                open: false,
                q: "",
              });
              props.setter({
                ...props.lvl7State,
                ingredientID: value.id,
              });
              return;
            }
            setNameSuggestion({
              ...nameSuggestion,
              selected: value.enName,
              open: false,
              q: "",
            });
            props.setter({
              ...props.lvl7State,
              ingredientID: value.id,
              faName: value.faName,
              enName: value.enName,
            });
          } else {
            setNameSuggestion({
              ...nameSuggestion,
              selected: "",
              q: "",
            });
            props.setter({
              ...props.lvl7State,
              ingredientID: undefined,
              faName: "",
              enName: "",
            });
          }
        }}
        open={nameSuggestion.open}
        onBlur={() => {
          setNameSuggestion({ ...nameSuggestion, open: false });
        }}
        clearOnEscape
        inputValue={
          nameSuggestion.selected ? nameSuggestion.selected : nameSuggestion.q
        }
        size="small"
        options={ingredientRes ? ingredientRes : []}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) =>
          option.enName ? option.enName : option.faName
        }
        renderInput={(params) => (
          <TextField
            {...params}
            error={props.stateValidation}
            variant="outlined"
            fullWidth
            onChange={(evt) => {
              setNameSuggestion({
                ...nameSuggestion,
                q: evt.target.value,
                selected: "",
              });
            }}
            autoFocus={true}
            label="نام عنصر"
          />
        )}
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllIngredientList((ingredients) => {
            setIngredientRes(ingredients);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/ingredients" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
